import { render, staticRenderFns } from "./SiteTreeContentAreas.vue?vue&type=template&id=491edfb5&scoped=true"
import script from "./SiteTreeContentAreas.vue?vue&type=script&lang=js"
export * from "./SiteTreeContentAreas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491edfb5",
  null
  
)

export default component.exports